const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement({
  SuperClass: HTMLDialogElement,
}) {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }

    this.inert = true
    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    const { activeDrawerClass, closingDrawerClass } = this.config.classes

    const hasMedia = this.hasAttribute('data-has-media')

    if (val) {
      this.classList.remove(closingDrawerClass)
      this.classList.add(activeDrawerClass)

      if (!this.hasAttribute('open')) {
        this.inert = false
        this.showModal()
      }
    } else {
      if (hasMedia) {
        // Close media first, then drawer
        this.classList.add(closingDrawerClass)

        window.setTimeout(() => {
          this.classList.remove(activeDrawerClass)
          this.classList.remove(closingDrawerClass)

          if (this.hasAttribute('open')) {
            this.inert = true
            this.close()
          }
        }, this.config.timings.closeDelay)
      } else {
        this.classList.remove(activeDrawerClass)
        this.inert = true
        this.close()
      }
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
        closingDrawerClass: 'drw-Drawer-closing',
      },
      timings: {
        closeDelay: 500,
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer, { extends: 'dialog' })
